$(document).ready(function() {
	$('.area-map__filter-toggle').on('click', function () {
		if ( $(this).hasClass('on') ) {
			$(this).removeClass('on').text( $(this).data('open-text') );
			$('.area-map__filter-buttons').slideUp();
		} else {
			$(this).addClass('on').text( $(this).data('close-text') );
			$('.area-map__filter-buttons').slideDown();
		}
	});
	
	$('.area-map__filter-map-toggle').on('click', function () {
		if ( $(this).hasClass('on') ) {
			$(this).removeClass('on').text( $(this).data('open-text') );
			$('.area-map__map').hide();
		} else {
			$(this).addClass('on').text( $(this).data('close-text') );
			$('.area-map__map').show();
		}
	});
	
	
	$('.area-map').each(function() {
		var $_filterElement = $(this);
		var $_filterItems = $_filterElement.find('.area-map__item');

		// Step 1: assemble a full list of each
		var filterCategories = '';
		var filterCategoriesCount = [];
		$_filterItems.each(function() {
			if (typeof $(this).data('filter-categories') !== 'undefined') {
				filterCategories += $(this).data('filter-categories') + '|';
			}
		});
		filterCategories = filterCategories.substring(0, filterCategories.length - 1); // remove trailing |
		filterCategories = filterCategories.split('|'); // make it an array
		//filterCategories = unique(filterCategories); // remove duplicates
		
		// Count all the cats and remove dupes
		var filterCategoriesTemp = [];
		$.each(filterCategories, function(itemIndex, arrayElement) {
			//if ($.inArray(e, result) == -1) result.push(e);
			var inArrayIndex = $.inArray(arrayElement, filterCategoriesTemp);
			
			if ( inArrayIndex == -1 ) {
				filterCategoriesTemp.push(arrayElement);
				filterCategoriesCount.push(1);
			} else {
				filterCategoriesCount[inArrayIndex] = filterCategoriesCount[inArrayIndex] + 1;
			}
		});
		filterCategories = filterCategoriesTemp;

		// Step 2: create the filter buttons
		var filterButtons = '<button class="all on">All <span>(' + $_filterItems.length + ')</span></button>';

		for (var category in filterCategories) {
			filterButtons += '<button data-filter-category="' + filterCategories[category] + '">' + filterCategories[category] + '<span>(' + filterCategoriesCount[category] + ')</button>';
		}

		$_filterElement.find('.area-map__filter-buttons').append(filterButtons);


		// Step 4: set up the button events
		var $_filterButtons = $_filterElement.find('.area-map__filter-buttons').find('button');

		$_filterButtons.on('click', function() {
			$('.area-map__filter-buttons').slideUp();
			$('.area-map__filter-toggle').removeClass('on').text( $('.area-map__filter-toggle').data('open-text') );
			$('.area-map__filter-label span').text( $(this).text().split('(')[0] );
			
			$(this)
				.siblings()
				.removeClass('on');

			// Clear the "All" button
			if (!$(this).hasClass('all')) {
				$_filterButtons.filter('.on').removeClass('on');
				$(this).addClass('on');
				var filterCategory = $(this).data('filter-category');

				// Trigger event to allow other JS to interact with the filter change
				$_filterElement.trigger('filter-changed', filterCategory);
				
				// Refresh the map
				// Refresh the map
				setTimeout(function () {
					buildMap( $('[data-area-map]') );
				}, 300);
				
			} else {
				// All button has been clicked, so show all buttons and return
				$_filterButtons.removeClass('on');
				$_filterButtons.filter('.all').addClass('on');

				$_filterItems.show();

				// Trigger event to allow other JS to interact with the filter change
				$_filterElement.trigger('filter-changed', null);
				
				// Refresh the map
				setTimeout(function () {
					buildMap( $('[data-area-map]') );
				}, 300);

				return;
			}

			// Only show the items that match the filter
			$_filterItems.each(function() {
				if (typeof $(this).data('filter-categories') !== 'undefined') {
					if (
						$(this)
							.data('filter-categories')
							.indexOf(filterCategory) > -1
					) {
						$(this).show();
						$(this).addClass('active');
					} else {
						$(this).hide();
						$(this).removeClass('active');
					}
				}
			});
		});
	});

	if ( $('.area-map').length > 0 ) {

		var url = window.location.href;
		var urlFilter = url.slice(url.indexOf('#'));
		
		switch (urlFilter) {
			case '#eat-drink':
				$('button[data-filter-category="Eat & Drink"]').trigger('click');
			break;
			case '#shop':
			$('button[data-filter-category="Shop"]').trigger('click');
			break;
			case '#relax':
				$('button[data-filter-category="Relax"]').trigger('click');
			break;
			case '#exercise':
				$('button[data-filter-category="Exercise"]').trigger('click');
			break;
			case '#see-do':
				$('button[data-filter-category="See & Do"]').trigger('click');
			break;
		}
	}

});

// Filter a list to only unique values
// https://stackoverflow.com/questions/12551635/jquery-remove-duplicates-from-an-array-of-strings
function unique(list) {
	var result = [];
	$.each(list, function(i, e) {
		if ($.inArray(e, result) == -1) result.push(e);
	});
	return result;
}
